"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _typographyStylex = require("web/shared/typography.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const styles = exports.styles = {
  status: {
    color: "xcdm7ny",
    fontSize: "x1hptrd9",
    $$css: true
  },
  error: {
    color: "xwiuzjs",
    fontSize: "x1jchvi3",
    $$css: true
  },
  section: {
    paddingTop: "x1q57ora",
    paddingBottom: "x163t5y5",
    $$css: true
  },
  titleRow: {
    display: "x78zum5",
    flexWrap: "x1a02dak",
    alignItems: "x1pha0wt",
    justifyContent: "x1qughib",
    gap: "x1tmakyn",
    rowGap: null,
    columnGap: null,
    margin: "x1xu1054",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    $$css: true
  },
  title: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x5pdnfe",
    fontWeight: "x1s688f",
    fontFamily: "xm3uy08",
    $$css: true
  },
  fact: {
    fontFamily: "xm3uy08",
    $$css: true
  },
  purpose: {
    margin: "x1hfpvee",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "xcdm7ny",
    fontSize: "x1jchvi3",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  orphansHeading: {
    margin: "xw8hiq5",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1hptrd9",
    fontWeight: "x1s688f",
    $$css: true
  },
  orphansNote: {
    margin: "x1hfpvee",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "xcdm7ny",
    fontSize: "xyr29y3",
    lineHeight: "x1evy7pa",
    $$css: true
  }
};